module.exports = __webpack_public_path__ + "static/media/screens_320.c89d4433.png";